import $ from 'jquery'

const regards = ()=> {
    const wrapper = document.querySelector('.regards__items')

    if( !wrapper )
        return

    //const reduce = Array.prototype.reduce
    const items = document.querySelectorAll('.regards__item')
    const itemsNumber = items.length
    const velocity = itemsNumber * 6000

    duplicateItems( items, itemsNumber, wrapper )
    const totalWidth = calculateTotalWidth(items)

    // initial position
    //const duplicateItemWidth = items[itemsNumber-1].offsetWidth
    wrapper.style.width = `${totalWidth * 2}px`
    //wrapper.style.marginRight = `-${duplicateItemWidth}px`
    const widthToAnimate = totalWidth


    $(wrapper).animate({ marginRight: `-${widthToAnimate}px` }, velocity * 2 , "linear", function() {
        wrapper.style.marginRight = 0
    })

    setInterval( function() {
    $(wrapper).animate({ marginRight: `-${widthToAnimate}px` }, velocity * 2 , "linear", function() {
        wrapper.style.marginRight = 0
    })}, velocity)
}

// Helpers
const calculateTotalWidth = items => {

    if( !items )
        return

    const itemsArray = Array.from(items)

        const totalWidth = itemsArray.reduce( (total, element)=>  total + (parseFloat(element.clientWidth)) , 0)

        return totalWidth

}

const duplicateItems = ( items, itemsNumber, wrapper ) => {
    
    const lastItem = items[itemsNumber-1]
    let allItems = ''
    items.forEach( item => {
       // wrapper.insertAdjacentElement('beforeEnd', item)
        wrapper.insertAdjacentHTML('beforeEnd', `<li class="regards__item">${item.innerHTML}</li>`)
    })
    

}

export default regards